<div class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4">
    <div class="flex items-start justify-between">
        <div class="text-xl font-medium tracking-tight leading-6 truncate">N. application/batch</div>

    </div>
    <div class="flex flex-col-reverse md:flex-row items-center flex-auto mt-6 h-auto">

        <app-dashboard-chart
                class="items-center justify-center w-full h-60 md:h-full mt-8 md:mt-0"
                [chartData]="applicationBatchDashboard"></app-dashboard-chart>

        <div class="-my-3 divide-y">
            <ng-container *ngFor="let dataset of batchData?.series; let i = index">
                <div class="grid custom-legend-grid py-3 ">
                    <div class="flex items-center truncate">
                        <div
                                class="flex-0 w-2 h-2 rounded-full"
                                [style.backgroundColor]="applicationBatchDashboard?.colors[i]"></div>
                        <div class="ml-3 truncate">{{applicationBatchDashboard?.labels[i]}}</div>
                    </div>
                    <div class="font-medium text-right">{{dataset.numberValue | number:'1.0-0'}}</div>
                    <div class="text-right text-secondary">{{dataset.percentageValue}}%</div>
                </div>
            </ng-container>
        </div>
    </div>

</div>
<!-- Overview -->

